import React, { type MouseEvent } from 'react';

const handleMouseDown = (e: MouseEvent): void => {
    e.stopPropagation();
};

interface ActionItemProps {
    children?: React.ReactNode;
}

export const ActionItem = ({
    children,
    ...rest
}: ActionItemProps): JSX.Element => (
    // This component prevents event bubbling for mouse actions in its children
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div data-test="action-item" onMouseDown={handleMouseDown} {...rest}>
        {children}
    </div>
);
